import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

const themes = [
  { id: "cyber", label: "Cyber", color: "#38bdf8" },
  { id: "midnight", label: "Midnight Gold", color: "#f5d347" },
  { id: "forest", label: "Forest", color: "#8db87c" },
  { id: "ember", label: "Ember", color: "#e8734a" },
  { id: "lavender", label: "Lavender", color: "#a78bfa" },
  { id: "botanica", label: "Botanica", color: "#4caf50" },
  { id: "sketch", label: "Sketch", color: "#dddddd" },
  { id: "tangerine", label: "Tangerine", color: "#e06030" },
  { id: "doom64", label: "Doom 64", color: "#d94040" },
];

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("portfolio-theme") || "midnight";
  });

  useEffect(() => {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("portfolio-theme", theme);
}, [theme]);

useEffect(() => {
  const hasSeenIntro = sessionStorage.getItem("theme-intro-done");
  if (hasSeenIntro) return;

  const btn = document.querySelector('[aria-label="Switch theme"]');
  if (!btn) return;

  let index = 0;
  const delay = 5000 / themes.length;

  const interval = setInterval(() => {
    index++;
    if (index < themes.length) {
      btn.style.borderColor = themes[index].color;
      btn.style.color = themes[index].color;
      btn.style.boxShadow = `0 0 12px ${themes[index].color}40, 0 0 4px ${themes[index].color}40`;
    } else {
      clearInterval(interval);
      btn.style.borderColor = '';
      btn.style.color = '';
      btn.style.boxShadow = '';
      sessionStorage.setItem("theme-intro-done", "true");
    }
  }, delay);

  return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);